export enum PATCH_STATUSES {
  CANCELLED = 'cancelled',
}

export enum PATCH_STATUSES_3DS {
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
}
